import api from '../../services/api';
import { Account } from '../../types/account/Account';
import AuthorizedBuyer from '../../types/customer/AuthorizedBuyer';
import { CustomerDetailsResponseData } from '../../types/customer/CustomerDetailsResponseData';
import { Order } from '../../types/order/Order';
import { PagingResponseData } from '../../types/response/PagingResponseData';
import ResponseError from '../../types/response/ResponseError';
import { AppThunkAction, AppThunkDispatch } from '../thunk';

import {
    getCustomerStarted,
    getCustomerSucceeded,
    getCustomerFailed,
    getOrdersSucceeded,
    getOrdersFailed,
    getAccountsFailed,
    getAccountsSucceeded,
    getOrdersStarted,
    getAccountsStarted,
    getBuyersStarted,
    getBuyersSucceeded,
    getBuyersFailed,
} from './customerSlice';

const getCustomerDetails =
    (customerId: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        dispatch(getCustomerStarted());

        try {
            const response = await api.get<CustomerDetailsResponseData>(`customers/${customerId}`);

            dispatch(getCustomerSucceeded(response));
        } catch (error) {
            if ((error as ResponseError).status === 404) {
                window.location.assign(`/orders?query=customerDetails.customerId:"${customerId}"`);
            }
            dispatch(getCustomerFailed(error as ResponseError));
        }
    };

const getCustomerDetailsByOrgId =
    (country: string, orgId: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        dispatch(getCustomerStarted());

        try {
            const response = await api.get<CustomerDetailsResponseData>(
                `customers/by/orgId/${orgId}`,
                undefined,
                undefined,
                0,
                undefined
            );

            dispatch(getCustomerSucceeded(response));
        } catch (error) {
            if ((error as ResponseError).status != 404)
                dispatch(getCustomerFailed(error as ResponseError));

            try {
                const response = await api.get<CustomerDetailsResponseData>(
                    `/${country}/organization/internal/${orgId}`,
                    undefined,
                    undefined,
                    0,
                    `${window.location.origin}/api/b2b`
                );
                dispatch(getCustomerSucceeded(response));
            } catch (error2) {
                dispatch(getCustomerFailed(error2 as ResponseError));
            }
        }
    };

const getOrders =
    (orderLink?: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        if (!orderLink) return;

        dispatch(getOrdersStarted());

        try {
            const response = await api.get<PagingResponseData<Order[]>>(orderLink);

            dispatch(getOrdersSucceeded(response));
        } catch (error) {
            dispatch(getOrdersFailed(error as ResponseError));
        }
    };

const getAccounts =
    (accountLink?: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        if (!accountLink) return;

        dispatch(getAccountsStarted());

        try {
            const response = await api.get<PagingResponseData<Account[]>>(accountLink);

            dispatch(getAccountsSucceeded(response));
        } catch (error) {
            dispatch(getAccountsFailed(error as ResponseError));
        }
    };

const getBuyers =
    (buyerLink?: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        if (!buyerLink) return;

        dispatch(getBuyersStarted());

        try {
            const response = await api.get<PagingResponseData<AuthorizedBuyer[]>>(
                buyerLink,
                undefined,
                undefined,
                undefined,
                `${window.location.origin}/api/b2b`
            );

            dispatch(getBuyersSucceeded(response));
        } catch (error) {
            dispatch(getBuyersFailed(error as ResponseError));
        }
    };

export default { getCustomerDetails, getCustomerDetailsByOrgId, getOrders, getAccounts, getBuyers };
